import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-136da23f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-muted" }, "加载中...", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("进行中")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("已完成")
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "游戏步骤回放", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "mb-2 text-muted" }
const _hoisted_12 = { class: "cards-grid" }
const _hoisted_13 = { class: "card-position" }
const _hoisted_14 = { class: "card-name" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "d-flex align-items-center mb-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "翻开位置:", -1))
const _hoisted_18 = {
  key: 0,
  class: "cards-grid small"
}
const _hoisted_19 = { class: "card-name small" }
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("配对成功!")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("未配对")
const _hoisted_23 = { class: "ms-2 text-muted" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "最终碰数:", -1))
const _hoisted_27 = {
  key: 0,
  class: "mt-2 d-flex align-items-center"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2" }, "获得奖励:", -1))
const _hoisted_29 = { class: "text-success" }
const _hoisted_30 = { class: "mt-4" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("返回列表")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_icon, {
            class: "is-loading",
            size: 30
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Loading)
            ]),
            _: 1
          }),
          _hoisted_3
        ]))
      : (_ctx.record)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_descriptions, {
              title: "游戏记录详情",
              column: 3,
              border: "",
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "记录ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.record.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "池子名称" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.record.match_pool?.name || '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "状态" }, {
                  default: _withCtx(() => [
                    (_ctx.record.status === 'playing')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "warning",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }))
                      : (_ctx.record.status === 'completed')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "success",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "用户昵称" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.record.user?.nickname || '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "用户手机" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.record.user?.mobile || '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "总碰数" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tag, {
                      type: _ctx.getMatchCountTagType(_ctx.record.total_matches),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.record.total_matches), 1)
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "奖励商品" }, {
                  default: _withCtx(() => [
                    (_ctx.record.reward_product)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_ctx.record.reward_product.image)
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                src: _ctx.record.reward_product.image,
                                "preview-src-list": [_ctx.record.reward_product.image],
                                fit: "cover",
                                style: {"width":"40px","height":"40px","margin-right":"8px"}
                              }, null, 8, ["src", "preview-src-list"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.record.reward_product.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, "无奖励"))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "成本" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(Number(_ctx.record.cost).toFixed(2)) + "元", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.record.created_at), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "更新时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.record.updated_at), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              shadow: "hover",
              class: "mb-4"
            }, {
              header: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_timeline, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.record.steps, (step, index) => {
                      return (_openBlock(), _createBlock(_component_el_timeline_item, {
                        key: index,
                        type: _ctx.getStepType(step),
                        hollow: step.type === 'init',
                        timestamp: _ctx.getStepTitle(step, index),
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, {
                            shadow: "never",
                            class: "step-card"
                          }, {
                            default: _withCtx(() => [
                              (step.type === 'init')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, "场上牌面（" + _toDisplayString(step.cards?.length) + "张）", 1),
                                    _createElementVNode("div", _hoisted_12, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.cards, (card, cardIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: cardIndex,
                                          class: _normalizeClass(["card-item", { 'matched': card.matched }])
                                        }, [
                                          _createElementVNode("div", _hoisted_13, "#" + _toDisplayString(card.position), 1),
                                          (card.product_image)
                                            ? (_openBlock(), _createBlock(_component_el_image, {
                                                key: 0,
                                                src: card.product_image,
                                                fit: "cover",
                                                class: "card-image"
                                              }, null, 8, ["src"]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_14, _toDisplayString(card.product_name), 1),
                                          _createVNode(_component_el_tag, {
                                            type: _ctx.getItemTypeTagType(card.item_type),
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(card.item_type), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["type"])
                                        ], 2))
                                      }), 128))
                                    ])
                                  ]))
                                : (step.type === 'flip')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      _createElementVNode("div", _hoisted_16, [
                                        _hoisted_17,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.positions, (pos) => {
                                          return (_openBlock(), _createBlock(_component_el_tag, {
                                            key: pos,
                                            class: "me-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" #" + _toDisplayString(pos), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      (step.cards && step.cards.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.cards, (card, cardIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: cardIndex,
                                                class: _normalizeClass(["card-item", { 'matched': step.matched }])
                                              }, [
                                                (card.product_image)
                                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                                      key: 0,
                                                      src: card.product_image,
                                                      fit: "cover",
                                                      class: "card-image"
                                                    }, null, 8, ["src"]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_19, _toDisplayString(card.product_name), 1),
                                                _createVNode(_component_el_tag, {
                                                  type: _ctx.getItemTypeTagType(card.item_type),
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(card.item_type), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["type"])
                                              ], 2))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_20, [
                                        (step.matched)
                                          ? (_openBlock(), _createBlock(_component_el_tag, {
                                              key: 0,
                                              type: "success"
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_21
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_el_tag, {
                                              key: 1,
                                              type: "info"
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_22
                                              ]),
                                              _: 1
                                            })),
                                        _createElementVNode("span", _hoisted_23, "当前总碰数: " + _toDisplayString(step.total_matches), 1)
                                      ])
                                    ]))
                                  : (step.type === 'end')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                          _hoisted_26,
                                          _createVNode(_component_el_tag, {
                                            type: _ctx.getMatchCountTagType(step.total_matches || 0),
                                            size: "large"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(step.total_matches), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["type"])
                                        ]),
                                        (step.reward_product_name)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                              _hoisted_28,
                                              (step.reward_product_image)
                                                ? (_openBlock(), _createBlock(_component_el_image, {
                                                    key: 0,
                                                    src: step.reward_product_image,
                                                    fit: "cover",
                                                    style: {"width":"40px","height":"40px","margin-right":"8px"}
                                                  }, null, 8, ["src"]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("span", _hoisted_29, _toDisplayString(step.reward_product_name), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["type", "hollow", "timestamp"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_el_button, { onClick: _ctx.goBack }, {
                default: _withCtx(() => [
                  _hoisted_31
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 2,
            description: "记录不存在"
          }))
  ]))
}